<script>
import { Inertia } from '@inertiajs/inertia';
import { inertia, page } from '@inertiajs/inertia-svelte'

</script>



<main>

  <slot />

</main>

<style>
:global(.svelecte .inputBox) {
  color: #444 !important;
}
:global(.svelecte .sv-content .sv-item-content) {
  max-width: 10rem;
}
</style>
